import application from "stimulus_application";
import SlideController from "./slide_controller";
import "./slide.css";

application.register("slide", SlideController);
